import { LoaderFunctionArgs, Outlet, redirect, useLoaderData, useLocation } from "react-router";
import { createDiscordServerPageURL, createProfilePageURL } from "#lib/urls";
import { FooterAd, SliderAd } from "#components/advs";
import { ProfilePageSkeleton } from "#components/pages";
import { Tabs } from "#components/creator-tabs";
import { paysites } from "#entities/paysites";
import { Creator, fetchCreator } from "#api/creators";
import { CreatorHeader } from "#components/creator-header";
import { useEffect } from "react";

interface IProps {
  creator: Creator;
}

export interface OutletContext {
  creator: Creator;
}

export function CreatorPage() {
  const { creator, creator: { service, name } } = useLoaderData() as IProps;
  const location = useLocation();
  const paysite = paysites[service];
  const title = `Posts of "${name}" from "${paysite.title}"`;
  let context: OutletContext = { creator };

  useEffect(() => {
    let segments = location.pathname.split("/");
    let lastSegment = segments[segments.length - 1];
    switch (lastSegment) {

    }
  }, [location.pathname]);

  return (
    <ProfilePageSkeleton name="user" title={title} creator={creator}>
      <CreatorHeader creator={creator} />
      <Tabs creator={creator} />

      <SliderAd />

      <Outlet context={context}></Outlet>

      <FooterAd />
    </ProfilePageSkeleton>
  );
}


export async function loader({ params }: LoaderFunctionArgs): Promise<IProps | Response> {
  const service = params.service?.trim() || "";
  const creatorId = params.creatorId?.trim() || "";

  if (service === "discord") {
    return redirect(String(createDiscordServerPageURL(creatorId)));
  }

  const creator = await fetchCreator(service, creatorId);

  if (creatorId == creator.public_id && creator.public_id != creator.id) {
    return redirect(String(createProfilePageURL({ service, creatorId: creator.id })));
  }

  return { creator };
}
